module.exports = __webpack_public_path__ + "media/petals.3d45a7ba.mp4";